var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon-pin-angle-fill',{staticClass:"pin-icon",attrs:{"color":_vm.isPinned ? '#E2037E' : '#A4A5A5'}})
}
var staticRenderFns = []

export { render, staticRenderFns }